import { deleteUndefinedOrNullProperties } from 'legacy/lut/helpers/deleteUndefinedOrNullProperties'

import { IPartner } from 'clickNgo/entities/partner/models'
import { I502Form } from 'clickNgo/models/crud/forms/i502Form'

export const mapPartnerFrom502Crud = (data: I502Form): Partial<IPartner> => {
  const mappedData: Partial<IPartner> = {
    companyEnglishName: data.CompanyEnglishName,
    companyLegalName: data.CompanyLegalName,
    companyLegalNameNonLatin: data.CompanyLegalNameNonLatin,
    legalAddressLine1: data.LegalAddr1,
    legalAddressLine2: data.LegalAddr2,
    legalAddressLine3: data.LegalAddr3,
    legalApproverComment: data.LegalApproverComment,
    legalCity: data.LegalCity,
    legalCountry: data.LegalCountry,
    entryId502: data.EntryId,
    legalModified: data.LegalModified,
    legalModifiedValues: data.LegalModifiedValues ? data.LegalModifiedValues : [],
    legalProfilingComment: data.LegalProfilingComment,
    legalState: data.LegalState,
    legalWorkflowStatus: data.LegalWorkflowStatus,
    legalZipCode: data.LegalPostalCode,
    partnerId: data.PartnerID,
  }

  return deleteUndefinedOrNullProperties(mappedData)
}
